/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarStatusFromJSON, CarStatusToJSON, } from './';
export function CarMainDtoFromJSON(json) {
    return CarMainDtoFromJSONTyped(json, false);
}
export function CarMainDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'carModelId': !exists(json, 'carModelId') ? undefined : json['carModelId'],
        'carModelName': !exists(json, 'carModelName') ? undefined : json['carModelName'],
        'carMakeId': !exists(json, 'carMakeId') ? undefined : json['carMakeId'],
        'carMakeName': !exists(json, 'carMakeName') ? undefined : json['carMakeName'],
        'garageId': !exists(json, 'garageId') ? undefined : json['garageId'],
        'plateNumber': !exists(json, 'plateNumber') ? undefined : json['plateNumber'],
        'vin': !exists(json, 'vin') ? undefined : json['vin'],
        'manufactureYear': !exists(json, 'manufactureYear') ? undefined : json['manufactureYear'],
        'firstRegistration': !exists(json, 'firstRegistration') ? undefined : (json['firstRegistration'] === null ? null : new Date(json['firstRegistration'])),
        'currentMileage': !exists(json, 'currentMileage') ? undefined : json['currentMileage'],
        'currentWorth': !exists(json, 'currentWorth') ? undefined : json['currentWorth'],
        'calendarColorRGB': !exists(json, 'calendarColorRGB') ? undefined : json['calendarColorRGB'],
        'status': !exists(json, 'status') ? undefined : CarStatusFromJSON(json['status']),
        'remarks': !exists(json, 'remarks') ? undefined : json['remarks'],
        'location': !exists(json, 'location') ? undefined : json['location'],
    };
}
export function CarMainDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'carModelId': value.carModelId,
        'carModelName': value.carModelName,
        'carMakeId': value.carMakeId,
        'carMakeName': value.carMakeName,
        'garageId': value.garageId,
        'plateNumber': value.plateNumber,
        'vin': value.vin,
        'manufactureYear': value.manufactureYear,
        'firstRegistration': value.firstRegistration === undefined ? undefined : (value.firstRegistration === null ? null : value.firstRegistration.toISOString()),
        'currentMileage': value.currentMileage,
        'currentWorth': value.currentWorth,
        'calendarColorRGB': value.calendarColorRGB,
        'status': CarStatusToJSON(value.status),
        'remarks': value.remarks,
        'location': value.location,
    };
}
